import 'react-multi-carousel/lib/styles.css';

import { useInView } from 'framer-motion';
import { forwardRef, useEffect, useRef, useState } from 'react';
import type {
  ButtonGroupProps,
  CarouselProps,
  ResponsiveType,
} from 'react-multi-carousel';
import Carousel from 'react-multi-carousel';

import useDeviceType from '@/app/hooks/useDeviceType';

import { RESPONSIVE_DATA } from './constants';

export type { ResponsiveType };
export type { ButtonGroupProps };

interface MultiCarouselProps extends CarouselProps {
  readonly autoPlayWhenVisible?: boolean;
}

const MultiCarousel = forwardRef<Carousel, MultiCarouselProps>(
  function MultiCarousel(
    {
      autoPlayWhenVisible = false,
      responsive = RESPONSIVE_DATA,
      children,
      ssr,
      ...props
    }: MultiCarouselProps,
    ref,
  ) {
    const [autoPlayInView, setAutoPlayInView] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const isInView = useInView(containerRef);

    // deviceType is required for SSR
    const deviceType = useDeviceType();

    useEffect(() => {
      if (isInView) {
        setAutoPlayInView(true);
      } else {
        setAutoPlayInView(false);
      }
    }, [autoPlayInView, isInView]);

    const autoPlay =
      props.autoPlay && autoPlayWhenVisible ? autoPlayInView : props.autoPlay;

    return (
      <div ref={containerRef} className="h-full">
        <Carousel
          autoPlay={autoPlay!}
          deviceType={deviceType}
          responsive={responsive}
          ref={ref}
          ssr={Boolean(ssr)}
          {...props}
        >
          {children}
        </Carousel>
      </div>
    );
  },
);

export default MultiCarousel;
